import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const Apply = () => {
  // Extract job details from URL query parameters
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const jobTitle = query.get('title') || 'Job Title';
  const jobDescription = query.get('description') || 'Job Description';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    resume: null,
    coverLetter: '',
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'resume') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic (e.g., send data to server)
    console.log('Form data submitted:', formData);
  };

  return (
    <div className="container mx-auto px-6 py-12 max-w-3xl">
      {/* Job Details Header */}
      <div className="bg-white shadow-lg rounded-lg p-6 mb-8">
        <h1 className="text-4xl font-semibold text-gray-800 mb-2">{jobTitle}</h1>
        <p className="text-gray-600 mb-4">{jobDescription}</p>
        <p className="text-sm text-gray-500">We are excited that you’re considering joining our team!</p>
      </div>

      {/* Application Form */}
      <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-lg p-6 space-y-6">
        {/* Name Input */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1" htmlFor="name" required>Full Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
            placeholder="Bla Bla"
          />
        </div>

        {/* Email Input */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1" htmlFor="email" required>Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
            placeholder="blabla@example.com"
          />
        </div>

        {/* Phone Number Input */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1" htmlFor="phone" required>Phone Number</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
            placeholder="+0 (000) 000-0000"
          />
        </div>

        {/* Resume Upload */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1" htmlFor="resume" required>Upload Resume</label>
          <input
            type="file"
            id="resume"
            name="resume"
            accept=".pdf,.doc,.docx"
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
          />
          <p className="text-xs text-gray-500 mt-1">Accepted formats: PDF, DOC, DOCX.</p>
        </div>

        {/* Cover Letter */}
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-1" htmlFor="coverLetter" required>Cover Letter</label>
          <textarea
            id="coverLetter"
            name="coverLetter"
            value={formData.coverLetter}
            onChange={handleChange}
            rows="5"
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
            placeholder="Tell us why you are a great fit for this position..."
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full py-3 rounded bg-blue-900 text-[#C5B358] text-lg transition-transform duration-300 hover:scale-105 hover:bg-[#013751]"
        >
          Submit Application
        </button>
      </form>
    </div>
  );
};

export default Apply;
